import { Cart } from './Cart'
import { CartItemSet } from './CartItemSet'

//we call this outside the hook to force initialization on page load
const instance = Cart.get()

export const useCart = (itemSet?: CartItemSet) => {
  if (itemSet) {
    instance.selectSet(itemSet)
  }
  return instance
}
